import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

function EditAccount() {
  const [account, setAccount] = useState();
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  let { aid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/accounts/${aid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setAccount(response.data.account);
      setName(response.data.account.name);
      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleNameChange = (evt) => {
    setName(evt.target.value);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/accounts/${aid}`,
        data: {
          name: name,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/accounts");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="new-account">
        <Col>
          <h4>Editar fraccionamiento</h4>
        </Col>
        <Col className="new-account-form">
          <Form>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Nombre del fraccionamiento"
                onChange={handleNameChange}
                value={name}
              />
            </Form.Group>
            <Form.Group>
              <Button variant="info" onClick={handleSubmit}>
                Guardar
              </Button>
              <Button variant="danger" onClick={() => navigate("/accounts")}>
                Cancelar
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Col>
    );
  }
}

export default EditAccount;
